import { ToolProvider } from '@/backend/types'
import { claude3HaikuTool } from '@/modules/Project/Tools/registry/claude3Haiku'
import type { ToolRegistryItem } from '@/modules/Project/Tools/tool-types'

export const claude3HaikuVertexAiTool: ToolRegistryItem = {
  ...claude3HaikuTool,
  addedAt: new Date('2024-01-01'),
  provider: ToolProvider.vertex_ai_claude,
  deprecated: true,
}
